import Phaser from 'phaser';
import { QuickDrawServiceAPI } from '../services/QuickDrawServiceAPI';
import { addAudio, addTextureBase64, loadAssets } from '../utils/AssetLoader';
const SpinSrc = require('../assets/default/audio/Casino_Spinning_Wheel.mp3');
const winningNumberRevealSrc = require('../assets/default/audio/Tile_Game_Connect.mp3');
const CardFlipSrc1 = require('../assets/default/audio/cards-flips/cards_flips_1.mp3');
const CardFlipSrc2 = require('../assets/default/audio/cards-flips/cards_flips_2.mp3');
const CardFlipSrc3 = require('../assets/default/audio/cards-flips/cards_flips_3.mp3');
const CardFlipSrc4 = require('../assets/default/audio/cards-flips/cards_flips_4.mp3');
const CardFlipSrc5 = require('../assets/default/audio/cards-flips/cards_flips_5.mp3');
const CardFlipSrc6 = require('../assets/default/audio/cards-flips/cards_flips_6.mp3');
const CardFlipSrc7 = require('../assets/default/audio/cards-flips/cards_flips_7.mp3');
const CardFlipSrc8 = require('../assets/default/audio/cards-flips/cards_flips_8.mp3');

export class PreloadingScene extends Phaser.Scene {
  constructor() {
    super('PreloadingScene');
  }

  preload() {
    this.preloadAudio();
    this.preloadImages();
    loadAssets(this, this.onLoadAssetsStart, this.onLoadAssetsComplete);
  }

  preloadAudio() {
    addAudio('Casino_Spinning_Wheel', SpinSrc.default);
    addAudio('Tile_Game_Connect', winningNumberRevealSrc.default);
    addAudio('CardFlipSrc1', CardFlipSrc1.default);
    addAudio('CardFlipSrc2', CardFlipSrc2.default);
    addAudio('CardFlipSrc3', CardFlipSrc3.default);
    addAudio('CardFlipSrc4', CardFlipSrc4.default);
    addAudio('CardFlipSrc5', CardFlipSrc5.default);
    addAudio('CardFlipSrc6', CardFlipSrc6.default);
    addAudio('CardFlipSrc7', CardFlipSrc7.default);
    addAudio('CardFlipSrc8', CardFlipSrc8.default);
  }

  preloadImages() {
    // // DO NOT remove - the base64 cache doesn't load if image loader is not initialized
    //this.load.image('_', '_');
    addTextureBase64('background', require('../assets/default/Background.png').default);
    const zeroPad = (num, places) => String(num).padStart(places, '0');
    for (let i = 0; i < 293; i++) {
      addTextureBase64(
        'background_' + i,
        require('../assets/default/background_animations/Background_00' + zeroPad(i, 3) + '.png').default
      );
    }
    addTextureBase64('topbar', require('../assets/default/Top bar.png').default);
    addTextureBase64('drawingid', require('../assets/default/drawingid_button.png').default);
    addTextureBase64('play', require('../assets/default/play.png').default);
    addTextureBase64('replay', require('../assets/default/replay.png').default);
    addTextureBase64('pause', require('../assets/default/pause.png').default);
    addTextureBase64('edit', require('../assets/default/edit.png').default);
    addTextureBase64('next_draw', require('../assets/default/next_draw.png').default);
    addTextureBase64('wheel', require('../assets/default/Wheel.png').default);
    addTextureBase64('ticker', require('../assets/default/ticker.png').default);
    addTextureBase64('get_ready', require('../assets/default/get_ready.png').default);
    addTextureBase64('done', require('../assets/default/done.png').default);
    addTextureBase64('otwlogo', require('../assets/default/Onetowinlogo.png').default);

    for (let i = 0; i < 6; i++) {
      addTextureBase64('countdown_' + i, require('../assets/default/Countdown_' + i + '.png').default);
    }
    for (let i = 1; i < 16; i++) {
      addTextureBase64('numberball_' + i, require('../assets/default/' + i + '.png').default);
    }

    // Make sure to change this if any other texture gets loaded after
    // this.lastTextureToBeLoaded = 'background_292';
  }

  create() {
    if (!!window._po_gm.config && !!window._po_gm.config.errorMsg) {
      this.scene.start('ErrorScene');
    }
  }

  private onLoadAssetsStart = () => {
    const screenWidth = 750;
    const screenHeight = 1334;
    this.add
      .text(screenWidth / 2, screenHeight / 2, 'Loading game...', {
        font: '40px odudo-semiBold',
        color: '#000'
      })
      .setOrigin(0.5);
  };

  private onLoadAssetsComplete = () => {
    window._po_gm.ready();
    //Uncomment this to start the game locally
    // window.po_gm.start({
    //   gameId: 183,
    //   drawId: '1',
    //   winningNumber: 10,
    //   winningPrize: 20,
    //   availableDraws: {
    //     '1': {
    //       winningNumber: 10,
    //       winningPrize: 20
    //     },
    //     '2': {
    //       winningNumber: 11,
    //       winningPrize: 50
    //     },
    //     '3': {
    //       winningNumber: 12,
    //       winningPrize: 100
    //     }
    //   }
    // });

    if (!window._po_gm.config) {
      this.makeDefaultConfigAndStartGame();
    }
  };

  getGameId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const gameId = urlParams.get('gameId');
    if (!!gameId) {
      return parseInt(gameId ? gameId : '0', 10);
    } else {
      return null;
    }
  }

  makeDefaultConfigAndStartGame() {
    const gameId = this.getGameId();
    if (!gameId) return;
    QuickDrawServiceAPI.getLatestQuickDrawWithWinnerResultByGame(gameId).then(response => {
      const config = {
        gameId,
        drawId: response.drawId,
        winningNumber: response.drawResult[0],
        winningPrize: response.prize,
        availableDraws: {}
      };
      window.po_gm.start(config);
    });
  }
}
